export const UPDATE_OPERATOR_DATA='OPERATORPAGE/UPDATE_OPERATOR_DATA'